
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin as observableForkJoin } from 'rxjs';
import { CommonOpsDataModel } from '../model/commonops.model';
import { MessageDetails } from '../model/message-details.model';
import { AppUtilityService } from './app-utility.service';
import { ConfigService } from './config.service';
import { LmsLoggerService } from './lms-logger.service';
import { MessageHandlerService } from './message-handler.service';
import { StaticDataStoreService } from './static-datastore.service';





/**
 * @export
 * @class MasterDataService
 */
@Injectable()
export class MasterDataService {

    private COMMON_MASTER_DATA_RESOURCE_URL = '/commonops/masterdata';
    private COMMON_INTENDED_USAGE_RESOURCE_URL = '/commonops/intentedUsage';
    private COMMON_PICKLIST_RESOURCE_URL = '/commonops/picklist';
    commonOpsDataModel: CommonOpsDataModel;
    configData: any;

    /**
     * Creates an instance of MasterDataService.
     * @param {HttpClient} http
     * @param {ConfigService} configService
     * @param {StaticDataStoreService} staticDataStoreService
     * @param {LmsLoggerService} lmsLoggerService
     * @param {MessageHandlerService} messageHandlerService
     * @param {Router} router
     *
     * @memberOf MasterDataService
     */
    constructor(private http: HttpClient,
        private configService: ConfigService,
        private staticDataStoreService: StaticDataStoreService,
        private lmsLoggerService: LmsLoggerService,
        private messageHandlerService: MessageHandlerService,
        private appUtilityService: AppUtilityService,
        private router: Router) {
        this.configData = this.configService.getConfigData();
    }

    /**
     * Handle error when service failed.
     * @param {any} error
     * @memberOf MasterDataService
     */
    handleError(error) {
        this.messageHandlerService.handleMessage(<MessageDetails>({
            type: this.configService.getConfigData().message.type.server,
            level: this.configService.getConfigData().message.level.error,
            target: this.configService.getConfigData().message.target.page,
            message: this.appUtilityService.getHttpErroMessage(error, false)
        }));
    }

    /**
     * Set response in staticDataStoreService.
     * @param {any} response
     * @memberOf MasterDataService
     */
    load(response) {
        if (response) {
            this.commonOpsDataModel = {};
            if (response[0]) {
                if (response[0].mapOfMnemoMilepost) {
                    this.commonOpsDataModel.mapOfMnemonis = response[0].mapOfMnemoMilepost;
                }
                if (response[0].setOfTerminals) {
                    this.commonOpsDataModel.setOfTerminals = response[0].setOfTerminals;
                    this.commonOpsDataModel.oprZoneList = Array.from(new Set(response[0].setOfTerminals.map(item =>item.oprZoneName))).map(oprZoneName =>{
                        return {
                            oprZoneName: oprZoneName,
                            oprZoneCode:response[0].setOfTerminals.find(obj => obj.oprZoneName == oprZoneName).oprZoneCode
                        }
                    });
                    this.commonOpsDataModel.oprRegionList = Array.from(new Set(response[0].setOfTerminals.map(item =>item.oprRegionName))).map(oprRegionName =>{
                        return {
                            oprRegionName: oprRegionName,
                            oprRegionCode:response[0].setOfTerminals.find(obj => obj.oprRegionName == oprRegionName).oprRegionCode
                        }
                    });
                    this.commonOpsDataModel.oprSubZoneList = Array.from(new Set(response[0].setOfTerminals.map(item =>item.oprSubZoneName))).map(oprSubZoneName =>{
                        return {
                            oprSubZoneName: oprSubZoneName,
                            oprSubZoneCode:response[0].setOfTerminals.find(obj => obj.oprSubZoneName == oprSubZoneName).oprSubZoneCode
                        }
                    });
                }
                console.log("########################### commonOpsDataModel ############################");
                console.log(this.commonOpsDataModel);
            }
            if (response[1]) {
                this.commonOpsDataModel.intendedUsageDataVO = response[1];
            }
            if (response[2]) {
                let allocationStationList = response[2];
                allocationStationList = response[2].allocationStationList.map((obj)=>{
                    return (response[0].setOfTerminals.find(sotObj => {
                        if(sotObj.terminalMnemonic == obj.allocationStation){
                            sotObj["divisionMnemonic"] = obj.divisionMnemonic;
                            sotObj["allocationStation"] = obj.allocationStation;
                            return sotObj;
                        }
                    }));
                }).filter((elem)=>elem!==undefined);
                console.log(allocationStationList);

                response[2].allocationStationList = allocationStationList
                this.commonOpsDataModel.masterData = response[2];
                let allocationRegionList = Array.from(new Set(allocationStationList.map(item => item.oprRegionName)))
                .map(oprRegionName =>{
                    return {
                        oprRegionName: oprRegionName,
                        oprRegionCode:allocationStationList.find(obj => obj.oprRegionName == oprRegionName).oprRegionCode,
                        allocatedStationList: allocationStationList.filter(station=>oprRegionName == station.oprRegionName)
                        .map(station =>station.allocationStation)
                    }
                });
                console.log("####allocationRegionList####");
                console.log(allocationRegionList);
                this.commonOpsDataModel.allocationRegionList = allocationRegionList;


                let allocationZoneList = Array.from(new Set(allocationStationList.map(item => item.oprZoneName)))
                .map(oprZoneName =>{
                    return {
                        oprZoneName: oprZoneName,
                        oprZoneCode:allocationStationList.find(obj => obj.oprZoneName == oprZoneName).oprZoneCode,
                        allocatedStationList: allocationStationList.filter(station=>oprZoneName == station.oprZoneName)
                        .map(station =>station.allocationStation)
                    }
                });
                const byAllocationZoneList = allocationZoneList.slice(0);
                byAllocationZoneList.sort((a,b) => {
                    const aCode = a.oprZoneCode.toLowerCase();
                    const bCode = b.oprZoneCode.toLowerCase();
                    return aCode  < bCode ? -1 : bCode > aCode ? 1 : 0
                })
                console.log("####allocationZoneList#####");
                console.log(byAllocationZoneList);
                this.commonOpsDataModel.allocationZoneList = byAllocationZoneList;

            }
            this.staticDataStoreService.putValue('commonopsPicklist', this.commonOpsDataModel);
            this.lmsLoggerService.logInfo('CommonopsPicklistService => load()',
                `Master Data Fetch Successfull for ${JSON.stringify(this.commonOpsDataModel)}`);
        }
    }

    /**
     * Service call for both master data from DB2 and common picklist service call.
     * @returns
     * @memberOf MasterDataService
     */
    getData() {
        this.lmsLoggerService.logInfo('MasterDataService=>getData service call starts');
        const opr = 'INQL';

        const masterDataHttpUrl =
            // this.http.get('data/master-data.json')
            this.http.get(`${this.configService.getConfigData().urls.API_URL}${this.COMMON_MASTER_DATA_RESOURCE_URL}?opr=${opr}`);

        const intendedUsageHttpUrl =
            // this.http.get('data/intendedUsage.json')
            this.http.get(`${this.configService.getConfigData().urls.API_URL}${this.COMMON_INTENDED_USAGE_RESOURCE_URL}?opr=${opr}`);

        const commonPicklistHttpUrl =
            // this.http.get('data/picklist.json')
            this.http.get(`${this.configService.getConfigData().urls.API_URL}${this.COMMON_PICKLIST_RESOURCE_URL}?opr=${opr}`);

        return observableForkJoin([masterDataHttpUrl, intendedUsageHttpUrl, commonPicklistHttpUrl]);
    }
}
